export const USER_COLUMNS =[
    {
        title:'序号',
        dataIndex:'序号'
    },
    {
        title:'账号',
        dataIndex:'账号'
    },
    {
        title:'名称',
        dataIndex:'名称'
    },
    {
        title:'职称',
        dataIndex:'职称'
    },
    {
        title:'状态',
        dataIndex:'状态'
    },
];